import styled from 'styled-components';
import { Z_INDEX } from 'common/styles';
import { CSSTransition } from 'react-transition-group';

const DEFAULT_TRANSITION_TIME = 150;
export interface ISplashScreen {
  isVisible?: boolean
  children?: React.ReactNode
  transitionTime?: number
  className?: string
}

const StyledContent = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 16px;
`

const StyledSplashScreen = styled.div<{ transitionTime: number }>`
  position: fixed;
  z-index: ${Z_INDEX.SPLASH};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, .75);
  
  display: flex;
  justify-content: center;
  align-items: center;

  &.modal {
    z-index: ${Z_INDEX.MODAL}
  }

  &.loader {
    z-index: ${Z_INDEX.LOADER};
  }

  &.splash-enter {
  opacity: 0;
    .content {
      transform: scale(0.8);
    }
  }

  &.splash-enter-active {
    opacity: 1;
    transition: opacity ${({ transitionTime }) => transitionTime}ms;
    .content {
      transform: translateX(0);
      transition: transform ${({ transitionTime }) => transitionTime}ms;
    }
  }

  &.splash-exit {
    opacity: 1;
  }

  &.splash-exit-active {
    display: none;
    opacity: 0;
    transition: opacity ${({ transitionTime }) => transitionTime}ms;
    .content {
      transform: scale(0.8);
      transition: transform ${({ transitionTime }) => transitionTime}ms;
    }
  }
`;

const SplashScreen: React.FC<ISplashScreen> = ({
  isVisible = false,
  transitionTime = DEFAULT_TRANSITION_TIME,
  className = '',
  children,
}) => (
  <CSSTransition
    in={isVisible}
    timeout={transitionTime}
    classNames="splash"
    unmountOnExit
  >
    <StyledSplashScreen
      transitionTime={transitionTime}
      className={className}
    >
      <StyledContent className="content">
        {children}
      </StyledContent>
    </StyledSplashScreen>
  </CSSTransition>
);

export default SplashScreen;
